import type { ViewEntity } from '@/engine/app/models/viewEntity/view.entity';
import type { ViewsService } from '@/engine/app/Views.service';
import { TYPES } from '@/engine/ioc';
import { inject, injectable } from 'inversify';
import { SetStepCommand } from './SetView.command';
import type { ICommand } from '@/engine/app/modules/core/interfaces/Command';

@injectable()
export class StepsListCommandsFactory {
  private readonly _viewsService: ViewsService;

  public constructor(@inject(TYPES.ViewsService) viewsService: ViewsService) {
    this._viewsService = viewsService;
  }

  public createSetStepCommand(view: ViewEntity): ICommand {
    return new SetStepCommand(this._viewsService, view);
  }
}
